/* ============================================================================
   tne-produtos.js — Carrossel de produtos público
   DistribuidorTopBioEuropa | Site institucional B2B

   REESCRITO (2026-06-09): a grelha + filtros deram lugar a um CARROSSEL
   automático em loop. Responsabilidades:
     1. Clonar os cards do track uma vez para o loop ser contínuo
        (a animação CSS desliza translateX 0 → -50%, ou seja exactamente
        uma cópia). Velocidade proporcional ao nº de cards.
     2. Pausa no hover/focus é feita 100% por CSS (animation-play-state).
     3. Tooltips do preço borrado (toggle em touch + Esc/click-outside).

   prefers-reduced-motion: NÃO clona nem anima — o carrossel fica um row
   com scroll horizontal manual (classe .is-static, ver CSS).

   NOTA: Este script NÃO toca em preços nem em dados sensíveis. Os clones
   são puramente visuais (aria-hidden, sem ids, fora da ordem de tabulação).
   ============================================================================ */
(function () {
  'use strict';

  var prefersReducedMotion = window.matchMedia &&
    window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function initTneProdutos(root) {
    if (!root || root.dataset.tneProdutosInit === '1') return;
    root.dataset.tneProdutosInit = '1';

    initCarousel(root);
    initPrecoTooltips(root);
  }

  // --------------------------------------------------------------------------
  // 1. Carrossel (marquee em loop)
  // --------------------------------------------------------------------------
  function initCarousel(root) {
    var carousel = root.querySelector('[data-tne-carousel]');
    var track = root.querySelector('[data-tne-carousel-track]');
    if (!carousel || !track) return;

    var originals = Array.prototype.slice.call(track.children);
    if (!originals.length) return;

    // Reduced-motion: sem animação nem clones — scroll manual.
    if (prefersReducedMotion) {
      carousel.classList.add('is-static');
      return;
    }

    // Duplica o conjunto de cards. Como o track passa a ter 2 cópias, a
    // animação translateX(-50%) termina exactamente onde começou → loop sem
    // costura. Os clones são decorativos: aria-hidden, sem ids, sem tabstop.
    originals.forEach(function (node) {
      var clone = node.cloneNode(true);
      clone.setAttribute('aria-hidden', 'true');
      stripInteractivity(clone);
      track.appendChild(clone);
    });

    // Velocidade constante: ~4.5s por card (mínimo 20s no total).
    var seconds = Math.max(20, originals.length * 4.5);
    track.style.setProperty('--tne-marquee-duration', seconds + 's');

    carousel.classList.add('is-ready');
  }

  // Remove ids (evita duplicados no DOM) e tira os clones da ordem de
  // tabulação/leitura — são apenas a "segunda volta" visual do loop.
  function stripInteractivity(clone) {
    if (clone.id) clone.removeAttribute('id');
    Array.prototype.forEach.call(clone.querySelectorAll('[id]'), function (el) {
      el.removeAttribute('id');
    });
    Array.prototype.forEach.call(clone.querySelectorAll('[aria-describedby]'), function (el) {
      el.removeAttribute('aria-describedby');
    });
    Array.prototype.forEach.call(clone.querySelectorAll('a, button, input, [tabindex]'), function (el) {
      el.setAttribute('tabindex', '-1');
    });
  }

  // --------------------------------------------------------------------------
  // 2. Tooltips do preço borrado (toggle em touch + Esc/click-outside fecha).
  // CSS já trata hover/focus desktop; este JS adiciona toggle persistente
  // para utilizadores touch que precisam de "agarrar" o tooltip aberto.
  // --------------------------------------------------------------------------
  function initPrecoTooltips(root) {
    var helpButtons = root.querySelectorAll('[data-tne-preco-help]');
    if (!helpButtons.length) return;

    function closeAll(except) {
      root.querySelectorAll('.tne-produto-card__preco-area.is-tip-open').forEach(function (area) {
        if (area === except) return;
        area.classList.remove('is-tip-open');
        var btn = area.querySelector('[data-tne-preco-help]');
        if (btn) btn.setAttribute('aria-expanded', 'false');
      });
    }

    helpButtons.forEach(function (btn) {
      btn.addEventListener('click', function (e) {
        e.preventDefault();
        e.stopPropagation();
        var area = btn.closest('[data-tne-preco-tip]');
        if (!area) return;
        var willOpen = !area.classList.contains('is-tip-open');
        closeAll(area);
        area.classList.toggle('is-tip-open', willOpen);
        btn.setAttribute('aria-expanded', willOpen ? 'true' : 'false');
      });
    });

    // Click fora fecha qualquer tooltip aberto.
    document.addEventListener('click', function (e) {
      if (!e.target.closest('[data-tne-preco-tip]')) closeAll(null);
    });

    // Escape fecha qualquer tooltip aberto.
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') closeAll(null);
    });
  }

  function boot() {
    document.querySelectorAll('[data-tne-produtos]').forEach(initTneProdutos);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  // Theme Editor — re-inicializa quando a secção é recarregada.
  document.addEventListener('shopify:section:load', function (event) {
    var root = event.target.querySelector('[data-tne-produtos]');
    if (root) {
      root.dataset.tneProdutosInit = '';
      initTneProdutos(root);
    }
  });
})();
